export function chunk<T>(array: T[], count: number) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0,
      length = array.length;
    while (i < length) {
      result.push(array.slice(i, (i += count)));
    }
    return result;
  }
  
  export function bin<T>(array: T[], columns: number) {
    const count = Math.ceil(array.length / columns);
  
    return chunk(array, count);
  }